import React, { useState } from 'react'
import styles from './Auth.module.css';
import { useNavigate } from 'react-router-dom';

const Auth = ()=> {

  const navigate = useNavigate();

  const [email,setEmail] = useState('');
  const [password , setPassword] = useState('');
  const [msg , setMsg] = useState('');

  const allowedEmails = [
    'shakul@inclusivestem.org',
    'kartik@inclusivestem.org',
    'chetan@inclusivestem.org',
    'library@nabdelhi.in',
    'pustakam.ebook@gmail.com',
    'library@nabdelhi.in'
  ]



  const handleSubmit = (e)=>{
    e.preventDefault();
   
    const pass = process.env.REACT_APP_PASSWORD;

    if(allowedEmails.includes(email)){
        console.log("email matched")
        if(password==pass)
        {
          localStorage.setItem('email',email);
          navigate('/upload-books');
        }else{
          setMsg("Password is incorrect");
        }
    }else{
        setMsg("You don't have access to your mail. Contact admin");
    }

    setEmail("");
    setPassword("");
  }

  return (
    <div className={styles.main}>
        <h1>Shravan IVR Portal</h1>
        <h2>Authenticate Here</h2>
        <div className={styles.formdiv}>
            <form onSubmit={handleSubmit}>
                <label htmlFor='email'>Enter your Email</label>
                <input type='email' id='email' value={email} onChange={(e)=>{setEmail(e.target.value)}}  />

                <label htmlFor='pass'>Enter your password</label>
                <input type='password' id='pass' value={password} onChange={(e)=>{setPassword(e.target.value)}}/>
                <button type='submit'>Login</button>
            </form>
            
        </div>
        <p className={styles.error}>{msg}</p>
    </div>
  )
}

export default Auth